import { render, staticRenderFns } from "./SaralaTable.vue?vue&type=template&id=07001532&"
import script from "./SaralaTable.vue?vue&type=script&lang=js&"
export * from "./SaralaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports